import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Entitlement => ');

const fetchEntitlements = createAction('fetch entitlements', (experienceId, promotionId) => ({
  experienceId,
  promotionId,
}));
const fetchEntitlementsSuccess = createAction('fetch entitlements success', (experienceId, promotionId, count) => ({
  experienceId,
  promotionId,
  count,
}));
const fetchEntitlementsFailure = createApiFailureAction('fetch entitlements failure');

export default {
  fetchEntitlements,
  fetchEntitlementsSuccess,
  fetchEntitlementsFailure,
};
